import { render, staticRenderFns } from "./TabsGuide.vue?vue&type=template&id=7365031b"
import script from "./TabsGuide.vue?vue&type=script&lang=js"
export * from "./TabsGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports